import { Theme, css } from '@emotion/react'

export const container = css`
  width: 100%;
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(2)};

  width: 100%;
`

export const modalTitle = css`
  display: block;

  font-weight: 700;
  text-align: center;
`

export const descriptionField = css`
  resize: vertical;
`

export const actionButtons = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(2)};
`

export const weekBlock = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing(2)};

  & > *:last-child {
    grid-column: 1 / -1;
  }
`
